import React from 'react';

interface IMotorcycleIconProps {
	size?: string;
	active?: boolean;
}

export const Motorcycle = ({ size = '106', active = false }: IMotorcycleIconProps) => {
	return active ? (
		<svg
			role="img"
			width={size}
			height={size}
			viewBox="0 0 109 106"
			fill="none"
			aria-labelledby="motorcycleActiveTitle">
			<title id="motorcycleActiveTitle">motorcycle illustration</title>
			<path d="M2 89.8108H108" stroke="#707070" strokeWidth="2" />
			<path d="M2 30H7" stroke="#707070" strokeWidth="2" />
			<path d="M10 30H24" stroke="#707070" strokeWidth="2" />
			<path d="M34 22H52" stroke="#707070" strokeWidth="2" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M80.6438 45.0389L84.8112 48.0823C86.549 49.3532 88.9872 48.1082 88.9872 45.964V39.8772C88.9872 37.7243 86.549 36.488 84.8112 37.7589L80.6438 40.8023C79.2086 41.8485 79.2086 43.9927 80.6438 45.0389Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				d="M75.8174 30.8653L73.0622 34.2302C72.7083 34.6625 72.7718 35.2999 73.2041 35.6538L75.8264 37.8009C76.2587 38.1549 76.896 38.0914 77.25 37.6591L80.0051 34.2942C80.359 33.8619 80.2955 33.2246 79.8633 32.8706L77.2409 30.7235C76.8086 30.3696 76.1713 30.4331 75.8174 30.8653Z"
				fill="#707070"
			/>
			<path
				d="M66.0494 18.2969L65.228 26.035"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M60.4468 35.269H68.8593L74.8597 39.4018"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M65.5396 23.0954C65.5396 23.0954 69.2487 23.0003 69.387 27.3406C69.5254 31.6809 69.387 35.6753 69.387 35.6753"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M18.5138 88.3035C10.1704 88.3035 3.3833 81.5164 3.3833 73.173C3.3833 64.8296 10.1704 58.0425 18.5138 58.0425C26.8572 58.0425 33.6443 64.8296 33.6443 73.173C33.6443 81.5164 26.8572 88.3035 18.5138 88.3035ZM18.5138 63.7661C13.3262 63.7661 9.10696 67.9854 9.10696 73.173C9.10696 78.3606 13.3262 82.5798 18.5138 82.5798C23.7014 82.5798 27.9207 78.3606 27.9207 73.173C27.9207 67.9854 23.7014 63.7661 18.5138 63.7661Z"
				fill="#EFEFEF"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				d="M18.5139 76.1992C20.1852 76.1992 21.54 74.8443 21.54 73.1731C21.54 71.5018 20.1852 70.147 18.5139 70.147C16.8426 70.147 15.4878 71.5018 15.4878 73.1731C15.4878 74.8443 16.8426 76.1992 18.5139 76.1992Z"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path d="M9.90234 78.1444L15.894 74.686" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M21.1338 71.6598L27.1255 68.2014" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M9.90234 68.2014L15.894 71.6598" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M21.1338 74.686L27.1255 78.1444" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M18.5137 63.23V70.1468" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M18.5137 76.199V83.1158" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M76.8051 37.9666L75.1451 39.0214L72.9058 37.3354L74.1681 35.8137L76.8051 37.9666Z"
				fill="#707070"
			/>
			<path
				d="M65.6344 76.1387C65.6344 76.1387 64.718 83.1765 59.7379 82.5799C54.7578 81.9834 39.7051 79.8132 39.7051 79.8132"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.43819 58.8035C7.43819 58.8035 10.691 55.0001 18.9998 55.0001C27.3087 55.0001 37.803 63.1265 41.2268 76.9774C49.0168 76.9774 70.2687 76.9947 70.2687 76.9947L79.1827 50.1056C79.1827 50.1056 76.0615 39.8255 65.5393 39.4019C56.7204 39.0474 47.8496 46.2149 46.4403 47.3994C46.302 47.5118 46.155 47.5983 45.9821 47.6502C44.6506 48.0738 38.4946 49.7684 31.794 47.5637C25.0933 45.359 23.6149 45.48 23.6149 45.48L12.7901 44.65C12.5653 44.6327 12.3491 44.7365 12.2108 44.918L9.9196 48.0479C9.70345 48.3505 9.81585 48.7741 10.153 48.9211L13.499 50.3823C13.499 50.3823 5.43232 52.1634 1.99121 58.7516L7.43819 58.8035Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M54.823 72H49.7172C47.3887 72 46 59.4329 46 59.4329C46 58.0852 46.525 57 47.177 57H54.823C55.475 57 56 58.0852 56 59.4329V69.5671C56 70.9148 55.475 72 54.823 72Z"
				fill="#ffcc00"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M65.9649 72H61.5288C60.685 72 60 70.8012 60 69.3246V59.6754C60 58.1988 60.685 57 61.5288 57H68.4712C69.315 57 70 58.1988 70 59.6754C70 59.6754 69.3233 72 65.9649 72Z"
				fill="#ffcc00"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38.4772 81.6461L9.51304 76.9254L5.43213 74.1154L6.59934 69.5676H11.9599L39.6444 77.4787C40.0161 77.5825 40.2323 77.9629 40.1285 78.3347L39.3418 81.1533C39.238 81.525 38.8576 81.7412 38.4858 81.6375L38.4772 81.6461Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinejoin="round"
			/>
			<path d="M86.5491 58.8294L76.8223 39.4019L73.7271 40.9495L83.4625 60.3771" fill="#F9F9F9" />
			<path
				d="M86.5491 58.8294L76.8223 39.4019L73.7271 40.9495L83.4625 60.3771"
				stroke="#707070"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M92.0045 88.3035C83.6611 88.3035 76.874 81.5164 76.874 73.173C76.874 64.8296 83.6611 58.0425 92.0045 58.0425C100.348 58.0425 107.135 64.8296 107.135 73.173C107.135 81.5164 100.348 88.3035 92.0045 88.3035ZM92.0045 63.7661C86.8169 63.7661 82.5977 67.9854 82.5977 73.173C82.5977 78.3606 86.8169 82.5798 92.0045 82.5798C97.1921 82.5798 101.411 78.3606 101.411 73.173C101.411 67.9854 97.1921 63.7661 92.0045 63.7661Z"
				fill="#EFEFEF"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				d="M92.0046 76.1992C93.6759 76.1992 95.0307 74.8443 95.0307 73.1731C95.0307 71.5018 93.6759 70.147 92.0046 70.147C90.3333 70.147 88.9785 71.5018 88.9785 73.1731C88.9785 74.8443 90.3333 76.1992 92.0046 76.1992Z"
				fill="#F9F9F9"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path d="M83.3931 78.1444L89.3847 74.686" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M94.6245 71.6598L100.616 68.2014" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M83.3931 68.2014L89.3847 71.6598" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M94.6245 74.686L100.616 78.1444" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M92.0044 63.23V70.1468" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M92.0044 76.199V83.1158" stroke="#707070" strokeWidth="2" strokeMiterlimit="10" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M46.4403 47.3994C47.8409 46.2149 56.7117 39.0474 65.5393 39.4019C68.8594 39.5316 71.4445 40.6555 73.4245 42.1167V47.7626C73.4245 47.7626 73.8741 51.2555 69.9315 51.2555C65.9889 51.2555 47.4519 51.342 47.4519 51.342L46.4316 47.3994H46.4403Z"
				fill="white"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.8024 47.5635C25.1018 45.3588 23.6233 45.4798 23.6233 45.4798L12.7985 44.6498C12.5737 44.6325 12.3576 44.7363 12.2192 44.9178L9.92805 48.0477C9.7119 48.3503 9.8243 48.774 10.1615 48.9209L13.5075 50.3821C13.5075 50.3821 20.1044 53.2267 29.762 53.5206C39.4196 53.8146 47.4604 51.5061 47.4604 51.5061L46.4401 47.4079C40.3605 45.0599 38.097 49.6346 31.8024 47.5635Z"
				fill="#DDDDDD"
				stroke="#707070"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
		</svg>
	) : (
		<svg role="img" width={size} height={size} viewBox="0 0 109 106" fill="none" aria-labelledby="motorcycleTitle">
			<title id="motorcycleTitle">motorcycle illustration</title>
			<path d="M2 89.8108H108" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M2 30H7" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M10 30H24" stroke="#A6A6A6" strokeWidth="2" />
			<path d="M33.9998 22H51.9998" stroke="#A6A6A6" strokeWidth="2" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M80.6438 45.039L84.8112 48.0824C86.549 49.3533 88.9872 48.1083 88.9872 45.9641V39.8773C88.9872 37.7244 86.549 36.4881 84.8112 37.759L80.6438 40.8024C79.2086 41.8486 79.2086 43.9928 80.6438 45.039Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				d="M75.8171 30.8654L73.062 34.2303C72.7081 34.6626 72.7716 35.2999 73.2038 35.6538L75.8262 37.801C76.2585 38.1549 76.8958 38.0914 77.2497 37.6591L80.0049 34.2942C80.3588 33.862 80.2953 33.2246 79.863 32.8707L77.2407 30.7235C76.8084 30.3696 76.1711 30.4331 75.8171 30.8654Z"
				fill="#A6A6A6"
			/>
			<path
				d="M66.0494 18.2969L65.228 26.035"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M60.4468 35.269H68.8593L74.8597 39.4018"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M65.5393 23.0954C65.5393 23.0954 69.2484 23.0003 69.3868 27.3406C69.5251 31.6809 69.3868 35.6753 69.3868 35.6753"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinecap="round"
			/>
			<path
				d="M18.5138 88.3036C10.1704 88.3036 3.3833 81.5165 3.3833 73.1731C3.3833 64.8297 10.1704 58.0426 18.5138 58.0426C26.8572 58.0426 33.6443 64.8297 33.6443 73.1731C33.6443 81.5165 26.8572 88.3036 18.5138 88.3036ZM18.5138 63.7662C13.3262 63.7662 9.10696 67.9855 9.10696 73.1731C9.10696 78.3607 13.3262 82.5799 18.5138 82.5799C23.7014 82.5799 27.9207 78.3607 27.9207 73.1731C27.9207 67.9855 23.7014 63.7662 18.5138 63.7662Z"
				fill="#EFEFEF"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				d="M18.5139 76.1992C20.1852 76.1992 21.54 74.8443 21.54 73.1731C21.54 71.5018 20.1852 70.147 18.5139 70.147C16.8426 70.147 15.4878 71.5018 15.4878 73.1731C15.4878 74.8443 16.8426 76.1992 18.5139 76.1992Z"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path d="M9.90234 78.1445L15.894 74.6861" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M21.1335 71.66L27.1252 68.2016" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M9.90234 68.2016L15.894 71.66" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M21.1335 74.6861L27.1252 78.1445" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M18.5139 63.2302V70.147" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M18.5139 76.1992V83.116" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M76.8051 37.9665L75.1451 39.0213L72.9058 37.3354L74.1681 35.8137L76.8051 37.9665Z"
				fill="#A6A6A6"
			/>
			<path
				d="M65.6344 76.1386C65.6344 76.1386 64.718 83.1765 59.7379 82.5799C54.7578 81.9833 39.7051 79.8132 39.7051 79.8132"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.43819 58.8034C7.43819 58.8034 10.691 55 18.9998 55C27.3087 55 37.803 63.1264 41.2268 76.9773C49.0168 76.9773 70.2687 76.9946 70.2687 76.9946L79.1827 50.1055C79.1827 50.1055 76.0615 39.8254 65.5393 39.4018C56.7204 39.0473 47.8496 46.2148 46.4403 47.3993C46.302 47.5117 46.155 47.5982 45.9821 47.6501C44.6506 48.0737 38.4946 49.7683 31.794 47.5636C25.0933 45.3589 23.6149 45.4799 23.6149 45.4799L12.7901 44.6499C12.5653 44.6326 12.3491 44.7364 12.2108 44.9179L9.9196 48.0478C9.70345 48.3504 9.81585 48.774 10.153 48.921L13.499 50.3822C13.499 50.3822 5.43232 52.1633 1.99121 58.7515L7.43819 58.8034Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M54.8228 72H49.7169C47.3884 72 45.9998 59.4329 45.9998 59.4329C45.9998 58.0852 46.5247 57 47.1767 57H54.8228C55.4748 57 55.9998 58.0852 55.9998 59.4329V69.5671C55.9998 70.9148 55.4748 72 54.8228 72Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M65.9647 72H61.5286C60.6848 72 59.9998 70.8012 59.9998 69.3246V59.6754C59.9998 58.1988 60.6848 57 61.5286 57H68.4709C69.3147 57 69.9998 58.1988 69.9998 59.6754C69.9998 59.6754 69.3231 72 65.9647 72Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M38.4772 81.6461L9.51304 76.9254L5.43213 74.1155L6.59934 69.5677H11.9599L39.6444 77.4788C40.0161 77.5825 40.2323 77.9629 40.1285 78.3347L39.3418 81.1533C39.238 81.5251 38.8576 81.7412 38.4858 81.6375L38.4772 81.6461Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
				strokeLinejoin="round"
			/>
			<path d="M86.5491 58.8293L76.8223 39.4018L73.7271 40.9494L83.4625 60.377" fill="#F9F9F9" />
			<path
				d="M86.5491 58.8293L76.8223 39.4018L73.7271 40.9494L83.4625 60.377"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M92.0048 88.3036C83.6614 88.3036 76.8743 81.5165 76.8743 73.1731C76.8743 64.8297 83.6614 58.0426 92.0048 58.0426C100.348 58.0426 107.135 64.8297 107.135 73.1731C107.135 81.5165 100.348 88.3036 92.0048 88.3036ZM92.0048 63.7662C86.8172 63.7662 82.5979 67.9855 82.5979 73.1731C82.5979 78.3607 86.8172 82.5799 92.0048 82.5799C97.1924 82.5799 101.412 78.3607 101.412 73.1731C101.412 67.9855 97.1924 63.7662 92.0048 63.7662Z"
				fill="#EFEFEF"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				d="M92.0049 76.1992C93.6761 76.1992 95.031 74.8443 95.031 73.1731C95.031 71.5018 93.6761 70.147 92.0049 70.147C90.3336 70.147 88.9788 71.5018 88.9788 73.1731C88.9788 74.8443 90.3336 76.1992 92.0049 76.1992Z"
				fill="#F9F9F9"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path d="M83.3933 78.1445L89.385 74.6861" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M94.6245 71.66L100.616 68.2016" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M83.3933 68.2016L89.385 71.66" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M94.6245 74.6861L100.616 78.1445" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M92.0049 63.2302V70.147" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path d="M92.0049 76.1992V83.116" stroke="#A6A6A6" strokeWidth="2" strokeMiterlimit="10" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M46.4403 47.3993C47.8409 46.2148 56.7117 39.0473 65.5393 39.4017C68.8594 39.5314 71.4445 40.6554 73.4245 42.1166V47.7624C73.4245 47.7624 73.8741 51.2554 69.9315 51.2554C65.9889 51.2554 47.4519 51.3419 47.4519 51.3419L46.4316 47.3993H46.4403Z"
				fill="white"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.8024 47.5636C25.1018 45.3589 23.6233 45.48 23.6233 45.48L12.7985 44.6499C12.5737 44.6326 12.3576 44.7364 12.2192 44.918L9.92805 48.0478C9.7119 48.3504 9.8243 48.7741 10.1615 48.9211L13.5075 50.3822C13.5075 50.3822 20.1044 53.2268 29.762 53.5207C39.4196 53.8147 47.4604 51.5062 47.4604 51.5062L46.4401 47.408C40.3605 45.06 38.097 49.6347 31.8024 47.5636Z"
				fill="#DDDDDD"
				stroke="#A6A6A6"
				strokeWidth="2"
				strokeMiterlimit="10"
			/>
		</svg>
	);
};
